import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import MainLayout from './layouts/MainLayout'
import ScrollToTop from './components/ScrollToTop'
import Home from './pages/Home'
import DashboardConcept from './pages/DashboardConcept'
import Onboarding from './pages/Onboarding'
import WellnessOnboarding from './pages/WellnessOnboarding'
import Events from './pages/Events'
import EventDetail from './pages/EventDetail'
import FacilitatorBookings from './pages/FacilitatorBookings'
import Facilitators from './pages/Facilitators'
import FacilitatorOnboarding from './pages/FacilitatorOnboarding'
import CreateFacilitator from './pages/CreateFacilitator'
import FacilitatorDetail from './pages/FacilitatorDetail'
import FacilitatorConsultationManage from './pages/FacilitatorConsultationManage'
import FacilitatorClassManage from './pages/FacilitatorClassManage'
import FacilitatorGalleryManage from './pages/FacilitatorGalleryManage'
import FacilitatorTestimonialManage from './pages/FacilitatorTestimonialManage'
import FacilitatorResourceManage from './pages/FacilitatorResourceManage'
import FacilitatorConsultations from './pages/FacilitatorConsultations'
import FacilitatorSlugEvents from './pages/FacilitatorSlugEvents'
import SpaceDetail from './pages/SpaceDetail'
import Meetup from './pages/Meetup'
import PersonalizedJourneys from './pages/PersonalizedJourneys'
import Build3Interest from './pages/Build3Interest'
import WellnessCollaborative from './pages/WellnessCollaborative'
import CohortSignup from './pages/CohortSignup'
import Build3CohortDashboard from './pages/Build3CohortDashboard'
import CohortAuthVerify from './pages/CohortAuthVerify'
import MidDayReset from './pages/MidDayReset'
import MidDayResetCheckIn from './pages/MidDayResetCheckIn'
import MidDayResetDashboard from './pages/MidDayResetDashboard'
import SessionCheckIn from './pages/SessionCheckIn'
import SessionFormResponses from './pages/SessionFormResponses'
import ParticipantDashboard from './pages/ParticipantDashboard'
import FacilitatorDashboard from './pages/FacilitatorDashboard'
import FacilitatorEvents from './pages/FacilitatorEvents'
import Login from './pages/Login'
import TestimonialSubmit from './pages/TestimonialSubmit'
import AdminLogin from './pages/AdminLogin'
import AdminDashboard from './pages/AdminDashboard'
import NotFound from './pages/NotFound'
// import RegistrationSuccess from './pages/RegistrationSuccess'
import TestSentryError from './pages/TestSentryError'
import CorporateLanding from './pages/CorporateLanding'
import FacilitatorLanding from './pages/FacilitatorLanding'
import HomeV2 from './pages/HomeV2'
import PrivacyPolicy from './pages/PrivacyPolicy'
import TermsOfService from './pages/TermsOfService'

const COHORT_7_SLUG = 'build3-cohort-7'
const MARCH_COHORT_SLUG = 'energizers-march-cohort'
const JUNE_COHORT_SLUG = 'energizers-june-cohort'

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        {/* Dashboard route outside MainLayout to use its own navbar */}
        {/* TODO: See if you can combined the build3 routes into a single route */}
        <Route
          path={`${COHORT_7_SLUG}/dashboard`}
          element={<Build3CohortDashboard programSlug={COHORT_7_SLUG} />}
        />
        <Route
          path={`${MARCH_COHORT_SLUG}/dashboard`}
          element={<Build3CohortDashboard programSlug={MARCH_COHORT_SLUG} />}
        />
        <Route
          path={`${JUNE_COHORT_SLUG}/dashboard`}
          element={<Build3CohortDashboard programSlug={JUNE_COHORT_SLUG} />}
        />
        
        {/* Mid Day Reset standalone pages */}
        <Route path="mid-day-reset" element={<MidDayReset />} />
        <Route path="mid-day-reset/check-in" element={<MidDayResetCheckIn />} />
        <Route path="mid-day-reset/dashboard" element={<MidDayResetDashboard />} />
        
        {/* Session check-in standalone pages */}
        <Route
          path="build3-energizer-session/:sessionNumber"
          element={<SessionCheckIn programSlug={COHORT_7_SLUG} />}
        />
        <Route
          path={`${MARCH_COHORT_SLUG}/session/:sessionNumber`}
          element={<SessionCheckIn programSlug={MARCH_COHORT_SLUG} />}
        />
        <Route
          path={`${JUNE_COHORT_SLUG}/session/:sessionNumber`}
          element={<SessionCheckIn programSlug={JUNE_COHORT_SLUG} />}
        />

        {/* Session form responses (facilitator/admin view) */}
        <Route
          path="programs/:slug/session/:sessionNumber/form-responses"
          element={<SessionFormResponses />}
        />
        
        {/* Standalone login page (outside MainLayout) */}
        <Route path="login" element={<Login />} />

        {/* Testimonial submission via invite token (standalone) */}
        <Route path="testimonial/:token" element={<TestimonialSubmit />} />
        
        {/* Admin pages - standalone (outside MainLayout) */}
        <Route path="admin/login" element={<AdminLogin />} />
        <Route path="admin" element={<AdminDashboard />} />
        <Route path="corporates" element={<CorporateLanding />} />
        <Route path="for-facilitators" element={<FacilitatorLanding />} />
        <Route path="home-v2" element={<HomeV2 />} />
        
        <Route path="/" element={<MainLayout />}>
          <Route index element={<HomeV2 />} />
          <Route path="onboarding" element={<Onboarding />} />
          <Route path="onboarding-wellness" element={<WellnessOnboarding />} />
          <Route path="dashboard-concept" element={<DashboardConcept />} />
          <Route path="dashboard" element={<ParticipantDashboard />} />
          <Route path="events" element={<Events />} />
          {/* <Route path="events/registration-success" element={<RegistrationSuccess />} /> */}
          <Route path="events/:slug" element={<EventDetail />} />
          <Route path="facilitators" element={<Facilitators />} />
          <Route path="facilitators/create" element={<CreateFacilitator />} />
          <Route path="facilitators/register" element={<FacilitatorOnboarding />} />
          <Route path="facilitators/edit-profile" element={<FacilitatorOnboarding />} />
          <Route path="facilitator/dashboard" element={<FacilitatorDashboard />} />
          <Route path="facilitator/events" element={<FacilitatorEvents />} />
          <Route path="facilitator/bookings" element={<FacilitatorBookings />} />
          <Route path="facilitator/consultations" element={<FacilitatorConsultationManage />} />
          <Route path="facilitator/classes" element={<FacilitatorClassManage />} />
          <Route path="facilitator/gallery" element={<FacilitatorGalleryManage />} />
          <Route path="facilitator/testimonials" element={<FacilitatorTestimonialManage />} />
          <Route path="facilitator/resources" element={<FacilitatorResourceManage />} />
          <Route path="facilitator/:slug/events" element={<FacilitatorSlugEvents />} />
          <Route path="facilitator/:slug/consultations" element={<FacilitatorConsultations />} />
          <Route path="facilitator/:slug" element={<FacilitatorDetail />} />
          <Route path="space/:id" element={<SpaceDetail />} />
          <Route path="meetup/:id" element={<Meetup />} />
          <Route path="meetup/:id/personalized-journeys" element={<PersonalizedJourneys />} />
          <Route path="build3-interest" element={<Build3Interest />} />
          <Route path="wellness-collaborative" element={<WellnessCollaborative />} />
          <Route
            path={`${COHORT_7_SLUG}-signup`}
            element={<CohortSignup programSlug={COHORT_7_SLUG} />}
          />
          <Route
            path={`${COHORT_7_SLUG}-auth/verify`}
            element={<CohortAuthVerify programSlug={COHORT_7_SLUG} />}
          />
          <Route
            path={`${MARCH_COHORT_SLUG}-signup`}
            element={<CohortSignup programSlug={MARCH_COHORT_SLUG} />}
          />
          <Route
            path={`${MARCH_COHORT_SLUG}-auth/verify`}
            element={<CohortAuthVerify programSlug={MARCH_COHORT_SLUG} />}
          />
          <Route
            path={`${JUNE_COHORT_SLUG}-signup`}
            element={<CohortSignup programSlug={JUNE_COHORT_SLUG} />}
          />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="terms-of-service" element={<TermsOfService />} />
          <Route path="test-sentry-error-459219" element={<TestSentryError />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </Router>
  )
}

export default App
